import React, {forwardRef, useEffect, useRef, useState} from "react";
import BeneficiaryService from "../../../services/BeneficiaryService";
import {toast} from "react-toastify";
import InfoIcon from "@material-ui/icons/Info";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import {makeStyles} from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import ReactToPrint, {PrintContextConsumer} from "react-to-print";
import Spinner from "reactjs-simple-spinner";
import letterHeader from "../../../assets/images/letterhead.png";
import PoliciesService from "../../../services/PoliciesService";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        // backgroundColor: theme.palette.background.paper,
    },
    root1: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    paper: {
        position: 'absolute',
        width: "45%",
        backgroundColor: theme.palette.background.paper,
        border: '0.2px solid #000',
        boxShadow: theme.shadows[1],
        padding: theme.spacing(2, 4, 3),
    },
}));

const Summary = forwardRef((props, ref) => {

    const [policyHolder, setPolicyHolder] = useState({});
    const [policy, setPolicy] = useState({})
    const [agent, setAgent] = useState({})
    const [aggregator, setAggregator] = useState({})
    const [manager, setManager] = useState({})
    const [representative, setRepresentative] = useState({})
    const [loading, setLoading] = useState(false);
    const [loadingPolicy, setLoadingPolicy] = useState(false);
    //objects init
    const [beneficiary, setBeneficiary] = useState([]);
    const [beneficiaryCover, setBeneficiaryCover] = useState([]);


    useEffect(() => {
        setLoading(true)
        setLoadingPolicy(true);
        let id = JSON.parse(localStorage.getItem('policyId'));
        // setPolicy(JSON.parse(localStorage.getItem('policy')))
        setPolicyHolder(JSON.parse(localStorage.getItem('pHolder')))
        console.log('policyholder:', JSON.parse(localStorage.getItem('pHolder')))
        PoliciesService.getPolicy(id)
            .then(res => {
                console.log('policy from server: ', res.data)
                setPolicy(res.data.policy)
                setAgent(res.data.agent)
                setManager(res.data.manager)
                setRepresentative(res.data.representative)
                setAggregator(res.data.aggregator)
                setLoadingPolicy(false);
            })
            .catch(err => {
                toast.warning('Loading Policy Failed \n If error persists contact, System Administrator', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                console.log("error: ", err);
                setLoadingPolicy(false);
            })
        BeneficiaryService.getBeneficiaries(id).then(res => {

            if (res.status === 200) {
                console.log("beneficiary: ", res.data.beneficiary);
                //if true hide add button
                if (res.data.beneficiary.length === 0) {
                    setBeneficiary([])
                    setBeneficiaryCover([])
                    setLoading(false)
                } else {
                    setBeneficiary(res.data.beneficiary);
                    setBeneficiaryCover(res.data.beneficiary)
                    setLoading(false)
                }
            } else {
                toast.warning('Loading Beneficiary Failed \n If error persists contact, System Administrator', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                console.log("error: ", res);
            }

        }).catch(err => {
            toast.warning('Loading Beneficiary Failed \n If error persists contact, System Administrator', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            console.log("error: ", err);

        })


    }, [])

    return (
        <>
            {loading && loadingPolicy && (
                <div className="container">
                    <form className="loader">
                        <div className="login-wrap p-5 mt-5">
                            <Spinner
                                size="large"
                                message="Loading data, Please Wait..."
                                line-fg-color="#64c3c2"
                            />
                        </div>
                    </form>
                </div>
            )}
            {!loading && !loadingPolicy && (
                <div className="ml-4 mr-4 mt-1 mb-3" ref={ref}>
                    <div className="row">
                        <img src={letterHeader} width="100%" height="30%" alt="Letter Head"/>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-6">
                            <hr/>
                            <div className="row">
                                <div className="col-md-12">
                                    <h4 className="text-primary"><strong>Policy Holder Information</strong>
                                    </h4>
                                </div>
                            </div>
                            <hr/>
                            <div className="row">
                                <div className="col-md-6">
                                    <h4><b>Name:</b> <span
                                        className="text-capitalize">{policyHolder.title}&nbsp;{policyHolder.first_name}&nbsp;{policyHolder.last_name}</span>
                                    </h4>
                                </div>
                                <div className="col-md-6">
                                    <h4><b>Occupation:</b> <span
                                        className="text-capitalize">{policyHolder.occupation}</span>
                                    </h4>
                                </div>
                                <div className="col-md-6">
                                    <h4><b>Date of Birth:</b> <span
                                        className="text-uppercase text-capitalize">{policyHolder.date_of_birth}</span>
                                    </h4>
                                </div>
                                <div className="col-md-6">
                                    <h4><b>Gender:</b> <span
                                        className="text-capitalize">{policyHolder.gender}</span></h4>
                                </div>
                                <div className="col-md-6">
                                    <h4><b>Marital Status: </b> <span
                                        className="text-capitalize">{policyHolder.status}</span></h4>
                                </div>
                                <div className="col-md-6">
                                    <h4><b>ID Number: </b>
                                        <span
                                            className="text-capitalize">{policyHolder.id_number}</span>
                                    </h4>
                                </div>
                                <div className="col-md-6">
                                    <h4><b>Smokers Status:</b> <span
                                        className="text-capitalize">{policyHolder.smoker_status}</span>
                                    </h4>

                                </div>
                                <div className="col-md-6">
                                    <h4><b>Salary:</b> <span
                                        className="text-uppercase">{policyHolder.salary}</span></h4>

                                </div>
                                <div className="col-md-6">
                                    <h4><b>EC Number:</b> <span
                                        className="text-uppercase">{policyHolder.ec_number}</span></h4>

                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <hr/>
                            <div className="row">
                                <div className="col-md-12">
                                    <h4 className="text-primary"><strong>Contact Details</strong></h4>
                                </div>
                            </div>
                            <hr/>
                            <div className="row">
                                <div className="col-md-6">
                                    <h4><strong>Mobile Number</strong></h4>
                                    <span className="text-uppercase">{policyHolder.mobile}</span>
                                </div>
                                <div className="col-md-6">
                                    <h4><strong>Alternative Number</strong></h4>
                                    <span
                                        className="text-uppercase">{policyHolder.work_telephone}</span>
                                </div>
                                <div className="col-md-6">
                                    <h4><strong>Email</strong></h4>
                                    <span className="text-lowercase">{policyHolder.email}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr/>
                    <div className="row">
                        <div className="col-md-12">
                            <h4 className="text-primary"><strong>Address Details</strong></h4>
                        </div>
                        <div className="col-md-6">
                            <h4 className="font-weight-bold">Physical Address</h4>
                            <address>
                                <span className="font-weight-bold">Street: </span>
                                <span
                                >{policyHolder.physical_address_street}</span>
                                <br/>
                                <span className="font-weight-bold">&nbsp;Suburb: </span>
                                <span
                                >{policyHolder.physical_address_suburb}</span>
                                <br/>
                                <span className="font-weight-bold">&nbsp; City: </span> <span
                            >{policyHolder.physical_address_city}</span>
                            </address>
                        </div>
                        <div className="col-md-6">
                            <h4 className="font-weight-bold">Postal Address</h4>
                            <address>
                                <span className="font-weight-bold">Street:</span> <span
                            >{policyHolder.postal_address_street}</span>
                                <br/>
                                <span className="font-weight-bold">&nbsp;Suburb: </span> <span
                            >{policyHolder.postal_address_suburb}</span>
                                <br/>
                                <span className="font-weight-bold">&nbsp;City: </span> <span
                            >{policyHolder.postal_address_city}</span>
                            </address>
                        </div>
                    </div>
                    <hr/>
                    <div className="row mt-2">
                        <div className="col-md-12">
                            <h4 className="text-primary"><strong>
                                <InfoIcon fontSize="medium"/>&nbsp;
                                Policy Information</strong></h4>
                        </div>
                    </div>
                    <hr/>
                    <div className="row mt-1">
                        <div className="col-md-3">
                            <h5><b>Policy Number:</b> <span>{policy.policy_number}</span>
                            </h5>
                        </div>
                        <div className="col-md-3">
                            <h5><b>Policy Type:</b> <span>{policy.policy_type}</span>
                            </h5>
                        </div>

                        <div className="col-md-3">
                            <h5><b>Inception Date:</b> <span>{policy.commencement_date}</span>
                            </h5>
                        </div>
                        <div className="col-md-3">
                            <h5><b>Eligible For Withdrawal:</b> <span>{policy.partial_withdrawal_date}</span>
                            </h5>
                        </div>
                        <div className="col-md-3">
                            <h5><b>Expected Maturity Date:</b> <span>{policy.expected_maturity_date}</span>
                            </h5>
                        </div>
                        <div className="col-md-3">
                            <h5><b>Industry:</b> <span>{policy.industry}</span>
                            </h5>
                        </div>
                        <div className="col-md-3">
                            <h5><b>Policy Status:</b> <span>{policy.policy_status}</span>
                            </h5>
                        </div>
                        <div className="col-md-3">
                            <h5><b>Premium Payer:</b> <span>{policy.premium_payer}</span>
                            </h5>
                        </div>
                        <div className="col-md-3">
                            <h5><b>Financial Advisor Code:</b> <span>{policy.financial_advisor_reference}</span>
                            </h5>
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <h5 className="font-weight-bold"><b>Agent</b></h5>
                            <div className="row"><span>Name: {agent?.name} &nbsp;{agent?.surname}</span></div>
                            <div className="row"><span>Type: {agent?.agent_type}</span></div>
                            <div className="row"><span>Contact: {agent?.contact_number}</span></div>
                            <div className="row"><span>Channel: {agent?.channel}</span></div>
                            <div className="row"><span>Team: {agent?.team}</span></div>
                        </div>
                        <div className="col-md-6">
                            <h5 className="font-weight-bold"><b>Manager</b></h5>
                            <div className="row"><span>Name: {manager?.name} &nbsp;{manager?.surname}</span></div>
                            <div className="row"><span>Email: {manager?.email}</span></div>
                            <div className="row"><span>Contact: {manager?.contact_number}</span></div>
                            <div className="row"><span>Branch: {manager?.branch}</span></div>
                        </div>
                        <div className="col-md-6">
                            <h5 className="font-weight-bold"><b>Aggregator</b></h5>
                            <div className="row"><span>Name: {aggregator?.name}</span></div>
                            <div className="row"><span>Email: {aggregator?.email}</span></div>
                            <div className="row"><span>Contact: {aggregator?.contact_number}</span></div>
                            <div className="row">
                                <span>Address: {aggregator?.street}-{aggregator?.suburb}-{aggregator?.city}</span></div>
                        </div>
                        <div className="col-md-6">
                            <h5 className="font-weight-bold"><b>Representative</b></h5>
                            <div className="row">
                                <span>Name: {representative?.first_name}&nbsp;{representative?.last_name}</span></div>
                            <div className="row"><span>Email: {representative?.email}</span></div>
                            <div className="row"><span>Contact: {representative?.contact_number}</span></div>
                            <div className="row"><span>Designation: {representative?.category_name}</span></div>
                        </div>
                    </div>
                    <hr/>
                    <div className="row mt-2">
                        <div className="col-md-12">
                            <h4 className="text-primary"><strong><AccountBalanceIcon fontSize="medium"/>&nbsp;Payment
                                Information</strong></h4>
                        </div>
                    </div>
                    <hr/>
                    {!loading && (
                        <>
                            <div className="row mt-1">
                                <div className="col-md-3">
                                    <h5><b>First Payment Date:</b> <span>{policy.first_payment_date}</span>
                                    </h5>
                                </div>
                                <div className="col-md-3">
                                    <h5><b>Next Invoicing Date:</b> <span>{policy.next_invoicing_date}</span>
                                    </h5>
                                </div>

                                <div className="col-md-3">
                                    <h5><b>Payment Frequency:</b> <span>{policy.payment_frequency}</span>
                                    </h5>
                                </div>
                                <div className="col-md-3">
                                    <h5><b>Payment Method:</b> <span>{policy.payment_method}</span>
                                    </h5>
                                </div>

                            </div>
                            <div className="row mt-1">
                                <div className="col-md-3">
                                    <h5><b>Primary Premium:</b> <span>{policy.premium}</span>
                                    </h5>
                                </div>
                                <div className="col-md-3">
                                    <h5><b>Contract Premium:</b> <span>{policy.total_premium}</span>
                                    </h5>
                                </div>
                                {policy.payment_method === 'CASH' && (
                                    <>
                                        <div className="col-md-3">
                                            <h5><b>Mobile Account:</b> <span>{policy.mobile_account_name}</span>
                                            </h5>
                                        </div>
                                        <div className="col-md-3">
                                            <h5><b>Mobile Number:</b> <span>{policy.mobile_number}</span>
                                            </h5>
                                        </div>
                                    </>
                                )}

                            </div>
                            {policy.payment_method === 'DEBIT_ORDER' && (

                                <div className="row mt-1">
                                    <div className="col-md-3">
                                        <h5><b>Bank:</b> <span>{policy.bank_name}</span>
                                        </h5>
                                    </div>
                                    <div className="col-md-3">
                                        <h5><b>Branch:</b> <span>{policy.branch}</span>
                                        </h5>
                                    </div>

                                    <div className="col-md-3">
                                        <h5><b>Account Name:</b> <span>{policy.account_name}</span>
                                        </h5>
                                    </div>
                                    <div className="col-md-3">
                                        <h5><b>Account Number:</b> <span>{policy.account_number}</span>
                                        </h5>
                                    </div>

                                </div>
                            )}


                        </>
                    )}
                    <hr/>
                    <div className="row mt-2">
                        {beneficiaryCover.length > 0 && (
                            <div className="container">
                                <Typography variant="h5" gutterBottom>
                                    Beneficiary
                                </Typography>
                                <TableContainer component={Paper}>
                                    <Table aria-label="simple table">
                                        <TableBody>
                                            {beneficiary.map((b, i) => (
                                                <TableRow key={i}>
                                                    <TableCell component="th" scope="row">
                                                        {b.name}
                                                    </TableCell>
                                                    <TableCell>{b.surname}</TableCell>
                                                    <TableCell>{b.relationship}</TableCell>
                                                    <TableCell align="right">{b.date_of_birth}</TableCell>
                                                    <TableCell align="right">{b.id_number}</TableCell>
                                                    <TableCell align="right">{b.mobile_number}</TableCell>
                                                </TableRow>
                                            ))}

                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        )}

                    </div>
                    <hr/>
                    <div className="row mt-2 mb-5">
                        <div className="col-md-4">
                            <Typography variant="subtitle2" gutterBottom>
                                Date Created: &nbsp;{policy.created_at}
                            </Typography>
                            <Typography variant="subtitle2" gutterBottom>
                                Created By: &nbsp;{policy.created_by}
                            </Typography>
                        </div>
                        <div className="col-md-4">
                            <Typography variant="subtitle2" gutterBottom>
                                Date Modified: &nbsp;{policy.updated_at}
                            </Typography>
                            <Typography variant="subtitle2" gutterBottom>
                                Modified By: &nbsp;{policy.modified_by}
                            </Typography>
                        </div>

                    </div>
                    <hr/>
                </div>
            )}
        </>
    )
})

export default function IlifaSummaryToPrint() {
    const ref = useRef();

    return (
        <div id="" className="m-5 ps-container ps-theme-default">

            <ReactToPrint content={() => ref.current}>
                <PrintContextConsumer>
                    {({handlePrint}) => (
                        <>
                            <button className="btn btn-sm btn-secondary"
                                    onClick={handlePrint}>
                                Print this out!&nbsp;<i className="fa fa-print"/>
                            </button>
                        </>

                    )}
                </PrintContextConsumer>
            </ReactToPrint>
            <Summary ref={ref}/>

        </div>
    );
}

